var map = {
	"./avatar_1.png": "jCv3",
	"./avatar_2.png": "Vjpm",
	"./avatar_3.png": "qR7V",
	"./avatar_4.png": "hrMK",
	"./avatar_5.png": "te9P",
	"./avatar_6.png": "Y8qo",
	"./avatar_7.png": "1Tzv",
	"./avatar_8.png": "nLyU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Y7JG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/avatars ^\.\/avatar_.*\.png$
// module id = Y7JG
// module chunks = 0